<img
    #img
    [src]="image?.images?.fixed_height.url"
    [alt]="image?.alt"
    (load)="calculateRows()"
    style="margin: 5px; cursor: pointer"
/>
